import DuplicateUserError from './DuplicateUserError';

export default DuplicateUserError;
